(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('WipDialogController', WipDialogController);

    WipDialogController.$inject = ['$uibModalInstance', 'entity', 'AlertRules'];

    function WipDialogController ($uibModalInstance, entity, AlertRules) {
        var vm = this;

        vm.object = entity;
        vm.clear = clear;
        vm.confirm = confirm;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirm () {
            AlertRules.wipAlerts({warning:"all", wip:vm.object.wipStatus, objectUniqueCode:vm.object.objectUniqueCode}, onSuccess, onError);

        }

        function onSuccess() {
            vm.object.wipStatus = vm.object.wipStatus == 0 ? 2 : 0;
            $uibModalInstance.close(true);
        }

        function onError() {

        }
    }
})();
